import React from 'react';
import * as Flags from 'country-flag-icons/react/3x2';
import { CountryCode } from 'libphonenumber-js/min';

type CountryFlagProps = {
  code: CountryCode;
  className?: string;
};

const CountryFlag: React.FC<CountryFlagProps> = ({ code, className }) => {
  const Flag = code ? Flags[code as keyof typeof Flags] : undefined;

  if (!Flag) {
    return null;
  }

  return <Flag className={className} />;
};

export default CountryFlag;